import React from 'react'

import config from '../../data/config';
import { useSelectedCategory, useDispatch, updateCategory } from '../../context/AppContext';
import "../../style/Category.css"

const { category_order, category_info } = config;
const listCategories = category_order

//ここではカテゴリーを選択するタブを作成する
const Categories = () => {
  // 最初の状態はselectedCategory: PartsType.Hair
  const selectedCategoryId = useSelectedCategory();

  const dispatch = useDispatch();

  return (
    <div className='list-categories'>
      {/* 1.category_orderでmapで回しcategory_info内のnameとkeyを取りだす */}
      {/* 2.partTypeが同じならselectedのクラススタイルを設定する */}
      {listCategories.map((categoryId)=>{
        const category = category_info[categoryId] || {};
        const { name, key } = category;

        const handleClick = () => {
          dispatch(updateCategory(categoryId))
        }
        return (
          <div
            className={`category ${ selectedCategoryId === categoryId ? "selected" : "" }`}
            key={ key }
            onClick={handleClick}
          >
            <span className='parts-name'>{name}</span>
          </div>
        );
      })}
    </div>
  );
}

export default Categories
